
import { Button } from '../../../components/base/Button';

export const FeaturesSection = () => {
  const features = [
    {
      title: 'No-Log Policy',
      description: 'We never track, collect, or share your private data. Complete anonymity guaranteed.'
    },
    {
      title: 'Kill Switch',
      description: 'Automatic protection that blocks internet access if VPN connection drops unexpectedly.'
    },
    {
      title: 'Split Tunneling',
      description: 'Choose which apps use VPN while others access internet directly for optimized performance.'
    },
    {
      title: 'Multi-Device Support',
      description: 'Secure unlimited devices simultaneously with a single DUVANKA VPN account.'
    }
  ];

  const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="features" className="py-20 bg-white">
      <div className="container mx-auto px-6">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          <div>
            <h3 className="text-4xl md:text-5xl font-serif text-navy-900 leading-tight mb-8">
              Advanced Security<br />
              Features That<br />
              <span className="text-cyan-600">Protect You</span>
            </h3>
            
            <Button 
              onClick={() => scrollToSection('contact')}
              className="mb-8"
            >
              Contact Our Team
              <i className="ri-arrow-right-line ml-2"></i>
            </Button>
            
            <p className="text-sm text-gray-500">
              DUVANKA DOO • Registered in Serbia • Enterprise Security Solutions
            </p>
          </div>
          
          <div className="space-y-6">
            {features.map((feature, index) => (
              <div key={index} className="flex items-start space-x-4">
                <div className="w-2 h-2 bg-cyan-600 rounded-full mt-3 flex-shrink-0"></div>
                <div>
                  <h4 className="text-xl font-bold text-navy-900 mb-2">
                    {feature.title}
                  </h4>
                  <p className="text-gray-600 leading-relaxed">
                    {feature.description}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};
